import { constants } from './constants';
import { isValidToken, getTokenData } from './utils';

const token = isValidToken(localStorage.getItem('token'))
  ? JSON.parse(localStorage.getItem('token'))
  : null;

const initialState = token
  ? { loggedIn: !!token, user: { token, ...getTokenData(token) } }
  : {
    loggedIn: false,
    user: {}
  };

export function auth(state = initialState, action) {
  switch (action.type) {
  case constants.LOGIN_REQUEST:
    return {
      isLoading: true,
      loggingIn: true,
      user: action.user
    };
  case constants.LOGIN_SUCCESS:
    return {
      isLoading: false,
      loggedIn: true,
      user: action.user
    };
  case constants.LOGIN_UPDATE:
    return {
      isLoading: false,
      loggedIn: true,
      user: action.user
    };
  case constants.LOGIN_FAILURE:
    return {
      isLoading: false,
      loggedIn: false
    };
  case constants.RESET_REQUEST:
    return {
      isLoading: true,
      loggingIn: false
    };
  case constants.LOGOUT:
    return {};
  default:
    return state;
  }
}
